import { Link } from "react-router-dom";
import { Overline, PageTitle, Section, StatusTag } from "@/components/shared/Primitives";

const techTestId = (t) => `experiment-tech-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

export const ExperimentHero = ({ experiment }) => (
  <Section testId="experiment-hero" className="!pt-36 !pb-12">
    <div className="mb-8">
      <StatusTag tone="concept">Experiment / R&D</StatusTag>
    </div>
    <PageTitle
      overline={`Study ${experiment.id}`}
      testId="experiment-title"
      title={experiment.title}
      lead={experiment.summary}
    />
    <div className="mt-14 overflow-hidden rounded-2xl border border-white/10 shadow-[0_24px_70px_rgba(0,0,0,0.55)]">
      <img
        src={experiment.image}
        alt={experiment.alt}
        loading="eager"
        decoding="async"
        className="h-72 w-full object-cover md:h-[28rem]"
      />
    </div>
  </Section>
);

export const ExperimentBody = ({ experiment, next }) => (
  <Section testId="experiment-body" className="!pt-0">
    <div className="grid gap-12 lg:grid-cols-[2fr_1fr]">
      <p
        data-testid="experiment-description"
        className="max-w-2xl text-base leading-relaxed text-[#F4F6FB]/70 md:text-lg"
      >
        {experiment.description}
      </p>
      <aside className="rounded-2xl border border-white/10 bg-[#12141C]/45 p-8 backdrop-blur-xl lg:self-start">
        <Overline className="!text-[10px] !tracking-[0.35em]">Technology</Overline>
        <ul className="mt-6 space-y-4">
          {experiment.tech.map((t) => (
            <li
              key={t}
              data-testid={techTestId(t)}
              className="flex items-center gap-3 text-sm text-[#F4F6FB]/75"
            >
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#06B6D4]" />
              {t}
            </li>
          ))}
        </ul>
      </aside>
    </div>

    <div className="mt-20 flex flex-wrap items-center justify-between gap-6 border-t border-white/10 pt-10">
      <Link
        to="/experiments"
        data-testid="experiment-all-link"
        className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#F4F6FB]/50 transition-colors duration-300 hover:text-[#06B6D4]"
      >
        ← All Experiments
      </Link>
      <Link
        to={`/experiments/${next.slug}`}
        data-testid="experiment-next-link"
        className="group text-right"
      >
        <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/40">
          Next Study
        </span>
        <span className="font-display mt-1 block text-lg font-semibold text-[#F4F6FB] transition-colors duration-300 group-hover:text-[#8B5CF6] md:text-2xl">
          {next.title} →
        </span>
      </Link>
    </div>
  </Section>
);
